import { graphql } from '@/lib/__generated__';
import { apolloClient } from '@/lib/apollo/apollo-client';

export async function loadPaymentMethods() {
  const { data } = await apolloClient.query({
    query: graphql(`
      query LoadPaymentMethods {
        paymentMethods {
          savedPaymentMethods {
            ...PaymentMethod
          }
          supportedPaymentTypes
        }
      }
    `),
  });

  return data.paymentMethods;
}
